export const firstUpperLetter = (text?: string) =>
  text
    ? String(text)
        .split(' ')
        .map((item) => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase())
        .join(' ')
    : '';
